import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Field } from '@app/api/types'

import { BookingState, BookingSteps, SetTimeSlotsAction, TestVariantsIdsLocationFilter } from './types'

export const INITIAL_STATE: BookingState = {
  status: 'initial',
  createLeadStatus: 'initial',
  createLeadError: '',
  error: '',
  flowData: {
    currentStep: BookingSteps.Welcome,
    stepsNumber: 5
  },
  abTestsData: {
    testVariantIdLocationFilter: TestVariantsIdsLocationFilter.Undetermined
  },
  inputData: {}
}

export const slice = createSlice({
  name: 'booking',
  initialState: INITIAL_STATE,

  reducers: {
    setBookingStep: (state, action: PayloadAction<number>) => {
      state.flowData.currentStep = action.payload
    },
    setTestVariantIdLocationFilter: (state, action: PayloadAction<number>) => {
      state.abTestsData.testVariantIdLocationFilter = action.payload
    },
    errorBackgroundRequest: (state, action: PayloadAction<{ message: string }>) => {
      state.status = 'failure'
      state.error = action.payload.message
    },
    setTimeSlots: (state, action: PayloadAction<SetTimeSlotsAction>) => {
      state.flowData.dateFrom = action.payload.dateFrom
      state.flowData.dateTo = action.payload.dateTo
      state.flowData.timeSlots = action.payload.timeSlots
    },
    requestUpdateBookingInputData: state => {
      state.status = 'pending'
    },
    successUpdateBookingInputData: (state, { payload: { fieldName, fieldValue } }: PayloadAction<Field>) => {
      state.status = 'success'
      state.inputData[fieldName] = fieldValue
    },
    errorUpdateBookingInputData: (state, action: PayloadAction<string>) => {
      state.status = 'failure'
      state.error = action.payload
    },
    setDiagnosisUserAnswer: (state, action: PayloadAction<string>) => {
      state.inputData.diagnosisUserAnswer = action.payload
    },
    setCurrentUtcTime: (state, action: PayloadAction<string>) => {
      state.status = 'success'
      state.flowData.currentUtcTime = action.payload
    },
    requestConfirmBooking: state => {
      state.status = 'pending'
    },
    successConfirmBooking: state => {
      state.status = 'success'
    },
    errorConfirmBooking: state => {
      state.status = 'failure'
    },
    requestCreateLead: state => {
      state.createLeadStatus = 'pending'
    },
    successCreateLead: state => {
      state.createLeadStatus = 'success'
    },
    errorCreateLead: (state, action: PayloadAction<string>) => {
      state.createLeadStatus = 'failure'
      state.createLeadError = action.payload
    },
    setInitialCreateLeadStatus: state => {
      state.createLeadStatus = 'initial'
    }
  }
})

export const { actions } = slice
export const bookingReducer = slice.reducer
